var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewContainer',{attrs:{"cvs":_vm.$store.getters['cvs/cvs'],"cv-design-template-samples":_vm.$store.getters['cvs/cvDesignTemplateSamples'],"cv-examples":_vm.$store.getters['cvs/cvExamples']}})}
var staticRenderFns = []

export { render, staticRenderFns }